//      

                                                  
                                                  
                                    
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import Search from "../components/Search";
import {customHistory} from "../helper/history";
import {clearSearchPreview, getSearchPreview} from "../actions/filter";
import currencyConverter from "../helper/currency";
                                                             
                                             

function mapStateToProps(state                  , ownProps           ) {
	return {
		searchPhrase: state.filter.fuzzy,
		preview: state.filter.searchPreview,
		showPrice: !state.cart.hidePrices,
		formatPrice: currencyConverter,
	};
}

function mapDispatchToProps(dispatch          , ownProps           ) {
	return {
		setSearch: fuzzy => customHistory.push("/search/" + fuzzy),
		fetchPreview: (typed        ) => dispatch(getSearchPreview(typed)),
		clearPreview: () => dispatch(clearSearchPreview()),
		openProduct: (product         ) => customHistory.push(`/product/${product.id}`),
		openCategory: (category                 ) => customHistory.push(`/category/${category.key}`),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Search));
